import { createUseFetch } from 'api/common/createUseFetch'
import { fetchRolesListApi } from 'api/roles/fetchers/fetchRolesListApi'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useFetchRolesListApi = createUseFetch({
  queryKey: ApiQueryKeys.ROLES_LIST,
  fetcher: fetchRolesListApi,
})
